export default __webpack_public_path__ + "static/media/zukunf_lauft_background_s1.104744b0.jpg";